<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @exps="exps"  @search="search" @reflash="reflash" @export="exps" ref="SetBtn"></buttonlist>
		<table>
			<tr>
				<td style="width:60px">{{ $t('getapi[1974]') }}</td>
				<td style="width:150px;">
					<el-select filterable v-model="cboyear"  size="mini" style="margin-righ:20px">
						<el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</td>
				<td style="width:60px">{{ $t('getapi[1975]') }}</td>
				<td style="width:150px;">
					<el-select filterable v-model="cbomonth"  size="mini" style="margin-righ:20px">
						<el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</td>
				<td>
					<el-button type="primary" size="mini" @click="createBalanceChange">{{$t('getapi[13156]')}}</el-button>
				</td>
			</tr>
		</table>
		<wTable
				id="xpane-0"
				:data="dataSet"
				:loading="loading"
				queryData="FinBalanceInventoryChange"
				:filter_thousandth="['init_qty','init_material_unit','init_man_unit','init_charge_unit','init_material_cost','init_man_cost','init_charge_cost',
                'receive_qty','receive_material_unit','receive_man_unit','receive_charge_unit','receive_material_cost','receive_man_cost','receive_charge_cost',
                'issue_qty','issue_qty_adjust','issue_material_unit','issue_man_unit','issue_charge_unit','issue_material_cost','issue_man_cost',
                'issue_charge_cost','issue_adjust_material_cost','issue_adjust_man_cost','issue_adjust_charge_cost','remain_qty','remain_material_unit',
                'remain_man_unit','remain_charge_unit','remain_material_cost','remain_man_cost','remain_charge_cost']"
				:header="tableHeader"
				:option="tableOption"
				ref="singleTable"
				:checkflg="false"
		></wTable>
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="FinBalanceInventoryChange" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[13157]')" queryData="FinBalanceInventoryChange" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
		<!-- 改变表格顺序 -->
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_finbalanceinventory',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight2,
                maxHeight: this.$windowSize.tableHeight2,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight2
        }
    },
	data() {
		return {
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('3_finbalanceinventory'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
            scrollTop:0,
            cboyear:'',
            cbomonth:'',
            monthList: [
                {
                    value: 1,
                    label:1
                },
                {
                    value: 2,
                    label:2
                },
                {
                    value: 3,
                    label:3
                },
                {
                    value: 4,
                    label:4
                },
                {
                    value: 5,
                    label:5
                },
                {
                    value: 6,
                    label:6
                },
                {
                    value: 7,
                    label:7
                },
                {
                    value: 8,
                    label:8
                },
                {
                    value: 9,
                    label:9
                },
                {
                    value: 10,
                    label:10
                },{
                    value: 11,
                    label:11
                },
                {
                    value: 12,
                    label:12
                }
            ],
            yearList: [],
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
        let year = new Date().getFullYear()
        that.yearList.push({
            value: year + 1,
            label: year + 1
        })
        for(let i=0;i<10;i++){
            that.yearList = [...that.yearList,{
                value: year - i,
                label: year - i
            }]
        }
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('FinBalanceInventoryChange',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6635]"),this.$t("getapi[6633]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			return;

		},
		btnauthority() {
			let that = this;
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('3_finbalanceinventory',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'FinBalanceInventoryChange');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost('CostCalc/InvView/GetFinBalanceInventoryChange', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "FinBalanceInventoryChange",
                fromname: that.$t('getapi[13157]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
        createBalanceChange(){
		    let that = this
            let parm = {
                cboyear: that.cboyear,
                cbomonth: that.cbomonth
            }
            that.$http.urlpost('/CostCalc/InvView/CreateBalanceChange', parm, function(res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }
            });
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
